import React,{useState,useEffect} from "react";
import Navbar from "./Navbar";
import Cookies from "js-cookie";
import url from "../../function/url";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
function Edit_Profile() {
    const ID = Cookies.get("log_id");
    const navigate = useNavigate();
    const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
          },
        });
    const [employee,setEmployeedetails] = useState({});
    const [otherdet,setOtherdetails] = useState({});

    const [image,setImage] = useState("");
    const [empname,setEmpname] = useState("");
    const [empID,setEmpID] = useState("");
    const [empEmail,setEmpEmail] = useState("");
    const [username,setUsername] = useState("");
    const [contact,setContact] = useState("");
    const [Department,setDepartment] = useState("");
    const [stream,setStream] = useState("");
    const [doj,setDoj] = useState("");
    const [Qualification,setQualification] = useState("");
    const [permanent,setPermanent] = useState("");
    const [temporary,setTemporary] = useState("");
    const [blood,setBlood] = useState("");
    function FetchProfiledetails() {
        axios.get(`${url.path}/fetch_profile_details/${ID}/`)
        .then((res) =>{
            if (res.data.status) {
                var emp = res.data.profile;
                var other = res.data.other;
                if (emp.profile) {
                    var img = `${url.path}/${emp.profile}`
                    setImage(img);
                }
                setEmpname(emp.Employee_Name);
                setEmpID(emp.Employee_ID);
                setEmpEmail(emp.Email);
                setContact(emp.Contact_number);
                setUsername(other.username);
                setDepartment(emp.Department);
                setStream(emp.Stream);
                setDoj(emp.Date_Of_Joining);
                setQualification(emp.Qualification);
                setPermanent(emp.Permanent_Address);
                setTemporary(emp.Temporary_Address);
                setBlood(emp.Blood_Group);
                
            }
        })
        .catch((err) => {
            console.log("ERROR", err);
          });
    }
    useEffect(() =>{
        FetchProfiledetails();
    },[])
    function Update_Profile(e) {
        e.preventDefault();
        const formdata = new FormData();
        formdata.append('ID',ID);
        formdata.append('empname',empname);
        formdata.append('empID',empID);
        formdata.append('empmail',empEmail);
        formdata.append('empcont',contact);
        formdata.append('username',username);
        formdata.append('department',Department);
        formdata.append('stream',stream);
        formdata.append('doj',doj);
        formdata.append('qualification',Qualification);
        formdata.append('permanent',permanent);
        formdata.append('temp',temporary);
        formdata.append('blood',blood);
        axios.post(`${url.path}/update_profile/`,formdata)
        .then((res) =>{
            if (res.data.status){
                Toast.fire({
                    icon:'success',
                    title:'Profile Updated Successfully..',
                });
                navigate("/profile");
            }
        })
        .catch((err) => {
            Toast.fire({
                icon:'error',
                title: err,
            });
          });
    }
    return(
        <>
        <Navbar />
        <div className="content">
            
            <div className="form-container">
                <div id="ndiv">
                    <h1 style={{fontSize:'30px'}}>Edit Profile</h1>
                </div>
                <center>
                    <h3 style={{fontSize:'25px'}}>{empname}</h3>
                    {image ? (
                        <img src={image} alt="Profile" id="primg" />
                    ) : 
                    (
                        <img src="user8.jpeg" alt="Profile" id="primg"  />
                    )}
                    
                </center>
                <br />
                <form onSubmit={Update_Profile}>
                    <h4>Personal Information</h4>
                    <div className="form-group-row mt-4">
                        <div className="form-group">
                            <label>Employee Name</label>
                            <input type="text" value={empname} onChange={(e) =>setEmpname(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Employee ID</label>
                            <input type="text" value={empID} onChange={(e) =>setEmpID(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Email</label>
                            <input type="text" value={empEmail} onChange={(e) =>setEmpEmail(e.target.value)} />
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Username</label>
                            <input type="text" value={username} onChange={(e) =>setUsername(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Contact</label>
                            <input type="text" value={contact} onChange={(e) =>setContact(e.target.value)} />
                        </div>
                        {Department ? (
                            <div className="form-group">
                            <label>Department</label>
                            <input type="text" value={Department} onChange={(e) =>setDepartment(e.target.value)} />
                            </div>
                        ) : null}
                        
                        
                    </div>
                    <div className="form-group-row">
                        {stream ? (
                            <div className="form-group">
                            <label>Stream</label>
                            <input type="text" value={stream} onChange={(e) =>setStream(e.target.value)} />
                        </div>
                        ) : null}
                        {doj ? (
                            <div className="form-group">
                            <label>Date Of Joining</label>
                            <input type="date" value={doj} onChange={(e) =>setDoj(e.target.value)} />
                        </div>
                        ) : null}
                        
                        {Qualification ? (
                            <div className="form-group">
                            <label>Qualification</label>
                            <input type="text" value={Qualification} onChange={(e) =>setQualification(e.target.value)} />
                        </div>
                        ) : null}
                    </div>
                    <div className="form-group-row">
                        {permanent ? (
                            <div className="form-group">
                            <label>Permanent Address</label>
                            <input type="text" value={permanent} onChange={(e) =>setPermanent(e.target.value)} />
                        </div>
                        ) : null}
                        {temporary ? (
                            <div className="form-group">
                            <label>Temporary Address</label>
                            <input type="text" value={temporary} onChange={(e) =>setTemporary(e.target.value)} />
                        </div>
                        ) : null}
                        {blood ? (
                            <div className="form-group">
                            <label>Blood Group</label>
                            <input type="text" value={blood} onChange={(e) =>setBlood(e.target.value)} />
                        </div>
                        ) : null}
                        
                    </div>
                    {image ? (
                        <div className="form-group-row">
                        <div className="form-group">
                            <label>Profile Image</label>
                            <input type="file" onChange={(e) => setImage(e.target.files[0])} />
                        </div>
                    </div>
                    ) : null}
                    
                    <center>
                        <div className="row">
                            <button style={{ width:'150px',height:'40px',borderRadius:'10px',color:'black',backgroundColor:'gainsboro'}} type="submit">Update</button>
                        </div>
                    </center>
                </form>
                
            </div>

        </div>
        </>
    );
}
export default Edit_Profile;